/**
 * @fileoverview Module for `src/admin/DistrictTaxType.js`.
 */

import React, { Fragment } from 'react';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  BooleanField,
  BooleanInput,
  SimpleForm,
  required,
  Toolbar,
  SaveButton,
  Edit,
  EditButton,
  useNotify,
  maxLength,
} from 'react-admin';


/**
 * Displays API errors for district tax type mutations.
 *
 * @param {Object} error
 * @param {Function} notify
 * @returns {void}
 */
const errorHandler = (error, notify) => {
  if (error.status === 'Conflict') {
    notify(`Error: Tax Type must be Unique`);
  } else {
    notify(`Error: ${ error.body || error.message }`);
  }
};

/**
 * Shared edit inputs for district tax type records.
 *
 * @returns {JSX.Element} Shared form fields.
 */
const SharedInputs = () => (
  <Fragment>
    <BooleanInput source='isShown' validate={ [required()] } /> <br />
    <TextInput fullWidth label='Header' max source='headerText' validate={ [required(), maxLength(32)] } /> <br />
    <TextInput fullWidth label='SubText' source='subtext' validate={ [maxLength(96)] } /> <br />

  </Fragment>
);

/**
 * Edit toolbar for district tax type resources.
 *
 * @param {Object} props
 * @returns {JSX.Element} Toolbar with save action.
 */
const DistrictTaxTypeEditToolbar = (props) => (
  <Toolbar { ...props } >
    <SaveButton />
  </Toolbar>
);

/**
 * Edit view for district tax type display settings.
 *
 * @param {Object} props
 * @returns {JSX.Element} District tax type editor.
 */
export const DistrictTaxTypeEdit = (props) => {
  const notify = useNotify();
  /**
   * Delegates district tax type edit errors to the shared error handler for admin notification.
   */
  const onFailure = (error) => {
    errorHandler(error, notify);
  };

  return (
    <Edit onFailure={ onFailure } undoable={ false } { ...props } toolbar={ <DistrictTaxTypeEditToolbar /> }>
      <SimpleForm redirect='edit' toolbar={ <DistrictTaxTypeEditToolbar /> }>
        <TextInput disabled source='taxType' validate={ [required()] } />
        <SharedInputs />
      </SimpleForm>
    </Edit>
  );
};


/**
 * List view for district tax type configuration.
 *
 * @param {Object} props
 * @returns {JSX.Element} District tax type list.
 */
const DistrictTaxTypeList = (props) => (
  <List
    { ...props }
    bulkActionButtons={ false }
    sort={{ field: 'tax_type', order: 'DESC' }}
  >
    <Datagrid >
      <TextField source='tax_type' />
      <BooleanField source='is_shown' />
      <TextField source='header_text' />
      <TextField source='subtext' />
      <EditButton { ...props } />
    </Datagrid>
  </List>
);

export default DistrictTaxTypeList;
